import { axiosConnectorInstance } from "../App";

export const getTCConnection = (connectionUuid: string) => {
  return axiosConnectorInstance
    .get(`/connection/${connectionUuid}`)
    .then((res) => res.data);
};

export const TCLogIn = (connectionUuid: string, data: FormData) => {
  const client_id = data.get("client_id");
  const client_secret = data.get("client_secret");

  return axiosConnectorInstance.get(
    `/connection/${connectionUuid}/login/trimble-connect`,
    {
      params: {
        client_id: client_id,
        client_secret: client_secret,
      },
    }
  );
};

export const getTCProjects = (connectionUuid: string) => {
  return axiosConnectorInstance
    .get(`/connection/${connectionUuid}/trimble-connect/projects`)
    .then((res) => res.data);
};

export const setTCProject = (connectionUuid: string, projectId: string) => {
  return axiosConnectorInstance.post(
    `/connection/${connectionUuid}/trimble-connect/project?projectId=${projectId}`
  );
};
